const shuffleArray = (arr: []) => {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

const getRandomArrayItem = <T>(arr: T[]): T =>
  arr[Math.floor(Math.random() * arr.length)]

export { shuffleArray, getRandomArrayItem }
